import { MDText } from 'i18n-react';
import { noop } from 'lodash';

import { Modal } from '@motorway/motorway-storybook-cra';

import VehicleExteriorGradeTag from 'Components/shared/VehicleExteriorGradeTag/VehicleExteriorGradeTag';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import type { GradingValues, VehicleMainInfo } from 'Pages/vehicles/helpers/vehicle.schema';
import { formatVehicleName } from 'Utilities/formatters';

import exteriorGradingTexts from '../ExteriorGrading.texts';
import { ExteriorGradingAccordion } from '../ExteriorGradingAccordion/ExteriorGradingAccordion';
import { ExteriorGradingTable } from '../ExteriroGradingTable/ExteriorGradingTable';

import styles from './ExteriorGradingModal.module.scss';

const localT = new MDText(exteriorGradingTexts.modal);

interface ExteriorGradingModalProps {
	exteriorGrade: GradingValues;
	onDismissModal?: () => void;
	vehicleSpec: Pick<VehicleMainInfo, 'make' | 'model'>;
}

export const ExteriorGradingModal: React.FC<ExteriorGradingModalProps> = ({
	exteriorGrade,
	onDismissModal = noop,
	vehicleSpec,
}) => {
	const { make, model } = vehicleSpec;

	const {
		maxWidth: { breakpointTablet },
	} = useBreakpoint();
	const modalSize = breakpointTablet ? 'small' : 'large';

	return (
		<Modal noPadding contentClass={styles.content} dismissModal={onDismissModal} size={modalSize}>
			<div className={styles.header}>
				<h4 className={styles.title}>{localT.translate('title')}</h4>
				<div className={styles.makeModelExteriorGrade}>
					<h5 className={styles.subtitle}>{formatVehicleName({ make, model })}</h5>
					<VehicleExteriorGradeTag
						noBackground
						className={styles.exteriorGradeTag}
						exteriorGrade={exteriorGrade}
						textClassName={styles.exteriorGradeTagText}
					/>
				</div>
			</div>
			<div className={styles.vehicleGrading}>
				{breakpointTablet ? (
					<ExteriorGradingAccordion initialExteriorGrade={exteriorGrade} />
				) : (
					<ExteriorGradingTable />
				)}
			</div>
			<div className={styles.footer}>{localT.translate('disclaimer')}</div>
		</Modal>
	);
};
